<div class="empathy-preview">
  <div class="empathy-preview__title">
    <span class="fs__xl">Preview</span>
  </div>

  <div class="empathy-preview__content">
    @if (isTranslationsPreview$() && activeTranslationLanguage$()) {
      <empathy-translations-language-toggle></empathy-translations-language-toggle>
    }

    <empathy-device-wrapper [activeDevice]="previewDevice.Phone">
      <ng-content></ng-content>
    </empathy-device-wrapper>
  </div>
</div>
